import { render, staticRenderFns } from "./dialog-detail.vue?vue&type=template&id=96491602&"
import script from "./dialog-detail.vue?vue&type=script&lang=js&"
export * from "./dialog-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports